// Scroll lock helpers for mobile filters
let scrollY = 0;

function lockBodyScroll() {
  scrollY = window.scrollY;
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
  document.body.classList.add('scroll-lock');
}

function unlockBodyScroll() {
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  document.body.style.width = "";
  window.scrollTo(0, scrollY || 0);
  document.body.classList.remove('scroll-lock');
}

let priceUrlParam = '' //used to fix ranged price filtering
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      if (event.target.matches('input[type="search"]')) {
        this.onSearchInput(event);
      } else {
        this.onSubmitHandler(event);
      }
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapper');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
  }

  static renderProductGridContainer(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const newProductCount = parsedHTML.querySelector('#ProductCount');
    const currentProductCount = document.querySelector('#ProductCount');

    const newProductGrid = parsedHTML.querySelector('#product-grid');
    const currentProductGrid = document.querySelector('#product-grid');

    if (newProductCount && currentProductCount) {
      currentProductCount.innerHTML = newProductCount.innerHTML;
    }

    if (newProductGrid && currentProductGrid) {
      currentProductGrid.innerHTML = newProductGrid.innerHTML;

      currentProductGrid.classList.add('pageOne');
      currentProductGrid.dataset.pages = newProductGrid.dataset.pages;
    }

    // Update product reviews widgets
    if (typeof yotpoWidgetsContainer !== 'undefined' && typeof yotpoWidgetsContainer.initWidgets === 'function') {
      yotpoWidgetsContainer.initWidgets();
    }

    setTimeout(() => {
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      if (typeof initializeScrollZoomAnimationTrigger === 'function') initializeScrollZoomAnimationTrigger(html.innerHTML);
    }, 10);

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.remove('loading');
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const jsFilter = event ? event.target.closest('.js-filter') : undefined;

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersFormHeader .js-filter, #FacetFiltersForm .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    const facetDetailsArray = Array.from(facetDetailsElements);

    facetDetailsArray.forEach((elementToRender) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        currentElement.innerHTML = elementToRender.innerHTML;
      }
    });
    
    if (jsFilter) {
      const restoredElement = document.getElementById(jsFilter.id);
      const selector = restoredElement.classList.contains('mobile-facets__details')
        ? `.mobile-facets__close-button`
        : `.facets__toggle`;

      const elementToFocus = restoredElement.querySelector(selector);
      const isTextInput = event.target.getAttribute('type') === 'text';

      if (elementToFocus && !isTextInput) elementToFocus.focus();
    }

    // 

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML); 

    // Extra - Apply Price Range Slider
    extraFiltersSettings.applyPriceRangeSlider();
    extraFiltersSettings.updateFiltersCount();
  }

  static renderActiveFacets(html) {
    const activeFacets = '.active-facets';

    const activeFacetsElement = html.querySelector(activeFacets);
    if (!activeFacetsElement) return;
    document.querySelector(activeFacets).innerHTML = activeFacetsElement.innerHTML;

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    //document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const target = event.target;

    if (target && target.matches('input[type="checkbox"]') && target.id && target.id.includes('filter.p.') && !target.checked) {
      const targetId = target.id;
      const checkboxName = targetId.split('filter.p.')[1];
      const selectCheckbox = document.querySelectorAll(`input[id*="${checkboxName}"]`);
      if (selectCheckbox && selectCheckbox.length > 1) {
        selectCheckbox.forEach((checkbox) => {
          checkbox.checked = false;
        });
      }
    }

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    sortFilterForms.forEach((form) => {
      const noJsElements = document.querySelectorAll('.no-js-list');
      noJsElements.forEach((el) => el.remove());

      let urlParams = this.createSearchParams(form);

      if (!urlParams) return;
      if (urlParams === 'sort_by=manual') return;

      if (urlParams.includes('price')) {
        const priceMinParam = 'filter.v.price.gte';
        const priceMaxParam = 'filter.v.price.lte';

        const searchParams = new URLSearchParams(urlParams);

        const priceMin = searchParams.get(priceMinParam);
        const priceMax = searchParams.get(priceMaxParam);

        if (priceMin === '') searchParams.delete(priceMinParam);
        if (priceMax === '') searchParams.delete(priceMaxParam);

        if (![...searchParams].length) return;

        urlParams = searchParams.toString();
      }

      forms.push(urlParams);
    });

    // Remove duplicate parameters
    const combinedParams = new URLSearchParams();
    const allParams = forms.join('&');
    const tempParams = new URLSearchParams(allParams);
    
    // Add each unique parameter only once
    for (const [key, value] of tempParams.entries()) {
      if (!combinedParams.has(key) || !combinedParams.getAll(key).includes(value)) {
        combinedParams.append(key, value);
      }
    }

    this.onSubmitForm(combinedParams.toString(), event);
  }

  onSearchInput(event) {
    event.preventDefault();
    const searchInput = event.target;
    const searchValue = searchInput.value.trim().toLowerCase();
    const facetsList = searchInput.closest('.facets__display')?.querySelector('.items-list');

    if (!facetsList) return;

    const facetItems = facetsList.querySelectorAll('.facets__item');
    facetItems.forEach((item) => {
      const label = item.querySelector('label');
      if (label) {
        const labelText = label.textContent.trim().toLowerCase();
        if (labelText.includes(searchValue)) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      }
    });

    const inputClearButton = searchInput.closest('.facets__search-content')?.querySelector('.facets__search-clear');
    if (!inputClearButton) return;

    const hasValue = searchValue.length > 0;
    inputClearButton.classList.toggle('hidden', !hasValue);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

//custom dossier logic
class ExtraFiltersSettings {
  init() {
    this.filtersWrapper = document.querySelector('.CAT__filters');
    this.facetFiltersFormHeader = document.querySelector('#FacetFiltersFormHeader');
    this.brandSearchWrapper = this.facetFiltersFormHeader.querySelector('.facets__search-wrapper');
    this.brandSearchInput = this.brandSearchWrapper?.querySelector('.facets__search');
    this.brandInputClearButton = this.brandSearchWrapper?.querySelector('.facets__search-clear');
    this.filtersAction = document.querySelector('.CAT-header__filters-action');
    this.filtersActionButton = this.filtersAction?.querySelector('.button__filters');
    this.filtersCloseIcon = this.filtersWrapper?.querySelector('.close-icon');
    this.filtersShowResults = this.filtersWrapper?.querySelector('.dossier-filter-button');
    this.toggleClassName = 'open';
    this.toggleFiltersClassName = 'filters-open';
    this.activeFacetsClass = 'has-active-facets';

    this.toggleDossierFilter();
    this.toggleDossierSort();
    this.changeDossierSortTitle();
    this.applyPriceRangeSlider();
    this.updateFiltersCount();
    this.brandInputClearButton?.addEventListener('click', (e) => this.clearSearchInput(e));
  }

  toggleDossierFilter() {
    if (!this.filtersWrapper || !this.filtersActionButton || !this.filtersCloseIcon || !this.filtersShowResults) return;

    const toggleFiltersElementsClass = () => {
      this.filtersActionButton.classList.toggle(this.toggleClassName);
      this.filtersWrapper.classList.toggle(this.toggleClassName);
      this.filtersWrapper.parentElement.classList.toggle(this.toggleFiltersClassName);
      if (window.innerWidth < 991) {
        if (this.filtersWrapper.classList.contains(this.toggleClassName)) {
          lockBodyScroll();
        } else {
          unlockBodyScroll();
        }
      }
    };


    if (!this.filtersActionButton._listenerAdded) {
      this.filtersActionButton.addEventListener('click', toggleFiltersElementsClass);
      this.filtersActionButton._listenerAdded = true;
    }

    this.filtersCloseIcon.addEventListener('click', toggleFiltersElementsClass);
    this.filtersShowResults.addEventListener('click', toggleFiltersElementsClass);

    if (this.filtersActionButton.classList.contains(this.toggleClassName)) {
      this.filtersWrapper.classList.add(this.toggleClassName);
      this.filtersWrapper.parentElement.classList.add(this.toggleFiltersClassName);
      if (window.innerWidth < 991) {
        lockBodyScroll();
      }
    }
  }

  toggleDossierSort() {
    let container = document.querySelector('.dossier-sort__modal');
    let openButton = document.querySelector(".dossier-sort__button");

    if (openButton) {
      openButton.addEventListener('click', (e) => {
        // Prevent the click inside the button from propagating to the document
        e.stopPropagation();
        e.currentTarget.classList.toggle('open');
        container.classList.toggle('open');
      })
    }
  }

  changeDossierSortTitle() {
    let container = document.querySelector('.dossier-sort__modal');
    if (container) {
      container.addEventListener('click', (e) => {
        if (e.target.matches('label')) {
          let newValue = e.target.textContent.trim();
          let selectedOption = document.querySelector('.dossier-sort__selected-option');
          if (selectedOption) {
            selectedOption.innerText = newValue;
          }
        }
      });
    }
  }

  applyPriceRangeSlider() {
    var priceSlider = document.getElementById('price-slider');
    if (!priceSlider) return;

    const minInput = document.querySelector('.filter__min_value');
    const maxInput = document.querySelector('.filter__max_value');

    const minPrice = parseInt(minInput.min);
    const maxPrice = parseInt(maxInput.max);
    const priceRange = maxPrice - minPrice;

    const rawStep = priceRange / 10;
    let step = Math.max(1, Math.ceil(rawStep / 10) * 10);

    const margin = Math.min(step, Math.max(1, priceRange / 10));

    if (priceSlider.noUiSlider) {
      priceSlider.noUiSlider.destroy();
    }

    noUiSlider.create(priceSlider, {
      start: [
        minInput.value ? parseInt(minInput.value) : minPrice,
        maxInput.value ? parseInt(maxInput.value) : maxPrice
      ],
      margin: margin,
      connect: true,
      range: {
        min: minPrice,
        max: maxPrice
      },
      step: step,
      tooltips: [true, true],
      format: {
        to: function (value) {
          return Number(value);
        },
        from: function (value) {
          return Number(value);
        }
      }
    });

    priceSlider.noUiSlider.on('change', function (values) {
      minInput.value = Number(values[0]);
      maxInput.value = Number(values[1]);

      const filterForm = document.querySelector('.facets__form');
      if (filterForm) {
        filterForm.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });

    minInput.addEventListener('change', function () {
      priceSlider.noUiSlider.set([this.value || 0, null]);
    });
    maxInput.addEventListener('change', function () {
      priceSlider.noUiSlider.set([null, this.value || maxPrice]);
    });
  }

  updateFiltersCount() {
    const mainCollectionFilters = document.getElementById('main-collection-filters');
    const facetRemoveItems = document.querySelectorAll('.facet-remove__item');
    const filtersCount = document.querySelectorAll('.filters-count');

    if (!mainCollectionFilters) return;

    const activeCount = facetRemoveItems.length;
    filtersCount.forEach(item => item.textContent = activeCount);

    if (activeCount > 0) {
      mainCollectionFilters.classList.add(this.activeFacetsClass);
    } else {
      mainCollectionFilters.classList.remove(this.activeFacetsClass);
    }
  }

  closeFilter() {
    this.filtersActionButton.classList.remove(this.toggleClassName);
    this.filtersWrapper.classList.remove(this.toggleClassName);
  }

  clearSearchInput(event) {
    event.preventDefault();

    const target = event.target;

    if (!this.brandSearchInput) return;

    this.brandSearchInput.value = '';
    this.brandInputClearButton.classList.add('hidden');

    const facetItems = target.closest('.facets__display').querySelectorAll('.facets__item');

    facetItems.forEach((item) => {
      item.style.display = '';
    });
  }
}

const extraFiltersSettings = new ExtraFiltersSettings();
extraFiltersSettings.init();

// Accordion component for facets
class FacetsAccordion extends HTMLElement {
  #handler;

  connectedCallback() {
    if (this.#handler) return;

    this.#handler = (e) => {
      const toggle = e.target.closest('.facets__toggle');
      if (toggle) {
        if (this.closest('#FacetFiltersFormHeader')) {
          this.closeSiblingAccordions();
        }

        const isOpen = this.classList.toggle('open');

        if(!this.closest('#FacetFiltersFormHeader')) return;

        if (window.innerWidth < 991) {
          if (isOpen) {
            lockBodyScroll();
          } else {
            unlockBodyScroll();
          }
        }

        return;
      }

      const action = e.target.closest('.facets__close, .facets__apply');
      if (action && action.closest('.facets__display')) {
        e.preventDefault();
        this.classList.remove('open');

        if(!this.closest('#FacetFiltersFormHeader')) return;
        if (window.innerWidth < 991) {
          unlockBodyScroll();
        }
      }
    };

    this.addEventListener('click', this.#handler);
  }

  disconnectedCallback() {
    if (this.#handler) {
      this.removeEventListener('click', this.#handler);
      this.#handler = null;
    }
  }

  closeSiblingAccordions() {
    const container = this.closest('#FacetFiltersFormHeader');
    if (!container) return;
    container.querySelectorAll('facets-accordion').forEach(acc => {
      if (acc !== this) {
        acc.querySelector('.facets__toggle')?.parentElement?.classList.remove('open');
      }
    });
  }
}

if (!customElements.get('facets-accordion')) {
  customElements.define('facets-accordion', FacetsAccordion);
}

// Close all header accordions when clicking outside
document.addEventListener('click', (event) => {
  if (!event.target.closest('.facets__toggle') && !event.target.closest('.facets__display')) {
    const anyOpenAccordion = document.querySelector('#FacetFiltersFormHeader facets-accordion.open');
    if (!anyOpenAccordion) return;

    // Close all accordions
    const allAccordions = document.querySelectorAll('#FacetFiltersFormHeader facets-accordion');
    allAccordions.forEach((accordion) => {
      const toggle = accordion.querySelector('.facets__toggle');
      if (toggle && toggle.parentElement) {
        toggle.parentElement.classList.remove('open');
      }
    });
    // Unlock body scroll if on mobile
    if (window.innerWidth < 991) {
      unlockBodyScroll();
    }
  }
});